import { render, staticRenderFns } from "./updateRecu.vue?vue&type=template&id=e6a93b52&"
import script from "./updateRecu.vue?vue&type=script&lang=js&"
export * from "./updateRecu.vue?vue&type=script&lang=js&"
import style0 from "./updateRecu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports